export const COLLAPSIBLE_ARRAOW_ICON_SIZE = 14;
export const COMPARISON_CAR_HEIGHT = 55;
export const COMPARISON_CAR_WIDTH = 73;
export const IOSCLOSE_SIZE = 10;

export const NUM_COMPARISON_MAX_VEHICLES = 4;
